import { Icon, IconProps } from "@chakra-ui/react";

export function Squiggle170x10Icon(props: IconProps) {
  return (
    <Icon {...props} viewBox="0 0 172 12">
      <path
        d="M1 1H97.8912L23.0207 11H171"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
